<div
    class="vstack"
>
    <div
        class="bg-body"
    >
        <div class="d-flex px-2 px-md-3">
            <div class="flex-grow-1 py-2 pe-2">
                <ul class="nav nav-pills d-flex flex-wrap">
                    <li
                        *ngFor="let area of areas"
                        class="nav-item"
                    >
                        <button
                            class="nav-link"
                            [ngClass]="area === selectedArea ? 'active' : ''"
                            (click)="selectArea(area)"
                        >
                            {{ area.displayName }}
                        </button>
                    </li>
                </ul>
            </div>

            <ng-container *ngIf="enableBulkSelection">
                <div class="vr my-2"></div>
                <div class="ps-3 d-flex align-items-center">
                    <button
                        class="btn btn-outline-secondary btn-sm"
                        [disabled]="!canSelectAllInSelectedArea()"
                        (click)="selectAllInArea()"
                    >
                        Select All in {{ selectedArea.displayName | slice: 0 : 15 }}
                    </button>
                </div>
            </ng-container>
        </div>
        <hr class="m-0"/>
    </div>
    <div
        class="my-1 vstack gap-2 flex-fill"
    >
        <div class="d-flex flex-column flex-lg-row flex-fill">
            <app-floor-plan
                class="flex-grow-1 d-flex"
                [tableViewModels]="viewModels"
                [venue]="venue"
                [containerWidth]="width"
                [containerHeight]="height"
                [fitToHeight]="fitToHeight"
                (bookingHover)="onBookingHover($event)"
            >
            </app-floor-plan>
            <ng-content></ng-content>
        </div>
    </div>
</div>
